module.exports = __webpack_public_path__ + "e16f24733a7991e6832ed140c2723077.woff2";